import cn from "classnames";
import { useTranslation } from "shared/localization/localization";
import { Button, ButtonProps } from "shared/ui/Button";
import styles from "./LoadMoreButton.module.scss";

type LoadMoreButtonProps = Omit<ButtonProps, "children" | "ref">;

export const LoadMoreButton: RFC<LoadMoreButtonProps> = ({ className, ...restProps }) => {
  const { t } = useTranslation();

  return (
    <Button variant="primary" size="small" className={cn(styles.loadMoreButton, className)} {...restProps}>
      {t("Load More")}
    </Button>
  );
};

LoadMoreButton.displayName = LoadMoreButton.name;
